import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { matchPath } from 'react-router'
import AlertCompanyNotVerified from '../AlertCompanyNotVerified'
import { ls } from 'utils/my-localstorage'
import { PersonCategories, Roles } from 'utils/consts/userRoles'
import { getPersonCategory } from 'utils/company'
import { CAPTURED_WINES_PATH } from 'utils/consts/path'
import { useAppSelector } from 'store/hooks'
import { getSelectedCompany } from 'store/me'
import { VERIFIED, PROHIBITED, REQUEST } from 'utils/consts/companyStatus'

const VISIBLE_ON_ROUTES = [
  `${CAPTURED_WINES_PATH}/all`,
  `${CAPTURED_WINES_PATH}/shortlist`,
]
interface VerificationAlertMainProps {
  onVerify: () => void
}
const VerificationAlertMain = ({ onVerify }: VerificationAlertMainProps) => {
  const [isRouteOk, setIsRouteOk] = useState(false)
  const company = useAppSelector(getSelectedCompany)

  const location = useLocation()
  const verificationCode = company?.verificationStatus?.code

  const isNotVerified = verificationCode !== VERIFIED
  const isNotProhibited = verificationCode !== PROHIBITED
  const isRequest = verificationCode === REQUEST

  const shouldShowAlert = isNotVerified && isNotProhibited && !isRequest

  useEffect(() => {
    const routeMatch = VISIBLE_ON_ROUTES.some(route =>
      matchPath(location.pathname, route)
    )
    setIsRouteOk(routeMatch)
  }, [location.pathname])

  const role = ls.getItem('wwl-role_code') || Roles.PERSON
  const category = getPersonCategory()
  const isCompany =
    role === Roles.PERSON && category !== PersonCategories.PERSON
  const isBuyer = category !== PersonCategories.PRODUCER

  if (!isRouteOk || !isCompany || !isBuyer) return null

  return shouldShowAlert ? (
    <AlertCompanyNotVerified onVerify={onVerify} />
  ) : null
}

export default VerificationAlertMain
